module.exports = __webpack_public_path__ + "img/ch.252c409b.svg";